import { OpportunityType } from '@indigo-ag/schema';
import i18next from 'i18next';

export const getTranslatedCropName = (cropName: string) => {
  switch (cropName.toLowerCase()) {
    case 'corn':
      return i18next.t('corn');
    case 'soybean':
      return i18next.t('soybean');
    case 'winter wheat':
      return i18next.t('winterWheat');
    case 'spring wheat':
      return i18next.t('springWheat');
    case 'oats':
      return i18next.t('oats');
    case 'cotton':
      return i18next.t('cotton');
    case 'sorghum':
      return i18next.t('sorghum');
    case 'barley':
      return i18next.t('barley');
    case 'rice':
      return i18next.t('rice');
    case 'chickpeas':
      return i18next.t('chickpeas');
    case 'faba beans':
      return i18next.t('fabaBeans');
    case 'mung beans':
      return i18next.t('mungBeans');
    default:
      return cropName;
  }
};

export const getCreditAssignmentStatusTranslation = (creditAssignmentStatus: string | undefined): string => {
  if (!creditAssignmentStatus) {
    return '-';
  }

  switch (creditAssignmentStatus) {
    case 'ASSIGNED':
      return i18next.t('creditAssignment/status-assigned');
    case 'NOT_ASSIGNED':
      return i18next.t('creditAssignment/status-notAssigned');
    case 'PAST_DUE':
      return i18next.t('creditAssignment/status-pastDue');
    default:
      return creditAssignmentStatus;
  }
};

export const getPaymentStatusTranslation = (paymentStatus: string | undefined): string => {
  if (!paymentStatus) {
    return '-';
  }

  switch (paymentStatus) {
    case 'DUE':
      return i18next.t('paymentStatus-due');
    case 'PAID_IN_FULL':
      return i18next.t('paymentStatus-paidInFull');
    case 'PAST_DUE':
      return i18next.t('paymentStatus-pastDue');
    case 'CANCELLED':
      return i18next.t('paymentStatus-cancelled');
    case 'APPROVED':
      return i18next.t('paymentStatus-approved');
    case 'DENIED':
      return i18next.t('paymentStatus-denied');
    case 'IN_PROGRESS':
      return i18next.t('paymentStatus-inProgress');
    case 'NOT_STARTED':
      return i18next.t('paymentStatus-notStarted');
    default:
      return paymentStatus;
  }
};

export const getCollateralTypeTranslation = (collateralType: string | undefined): string => {
  if (!collateralType) {
    return '-';
  }

  switch (collateralType) {
    case 'CPR':
      return 'CPR';
    case 'CPRF':
      return 'CPRF';
    case 'PROMISSORY_NOTE':
      return i18next.t('PROMISSORY_NOTE');
    case 'FIDUCIARY_SALE':
      return i18next.t('FIDUCIARY_SALE');
    case 'LETTER_OF_GUARANTEE':
      return i18next.t('LETTER_OF_GUARANTEE');
    case 'NOT_APPLICABLE':
      return i18next.t('NOT_APPLICABLE');
    case 'NOT_FOUND':
      return i18next.t('NOT_FOUND');
    default:
      return collateralType;
  }
};

export const getOpportunityTypeTranslation = (opportunityType: OpportunityType): string => {
  return i18next.t(`opportunityType-${opportunityType}`);
};
